<template>
  <div>
    <div v-if="game" :class="{ mobile: isMobile }">
      <page-tabs
        :currentPage="game.background.title"
        style="padding-left: 145px"
      ></page-tabs>

      <div class="usergame-container" v-if="isUserGame && userLoggedIn">
        <char-button
          class="user-button"
          :size="'small'"
          @click="triggerEditUserGame"
          >Edit</char-button
        >
        <char-button
          class="user-button"
          :size="'small'"
          @click="triggerDeleteUserGame"
          >Delete</char-button
        >
      </div>
      <div class="usergame-container" v-else-if="userLoggedIn">
        <char-button
          class="user-button"
          :size="'small'"
          @click="triggerCopyAndEditGame"
          >Make a copy and edit</char-button
        >
      </div>
      <div class="usergame-container" v-else>
        <char-button
          v-if="!showLoginBox"
          class="user-button"
          :size="'small'"
          @click="showLoginBox = true"
        >
          Login to edit game
        </char-button>
        <div class="login-box" v-if="showLoginBox">
          <login :size="'small'">Login to edit game</login>
        </div>
      </div>

      <h1 :class="{ withcreator: getOwnerLink || getOwnerName }">
        <span class="border"></span>{{ game.background.title
        }}<span class="border back"></span>
      </h1>
      <div class="game-creator" v-if="getOwnerLink || getOwnerName">
        <span>From </span>
        <a v-if="getOwnerLink" :href="getOwnerLink" target="_blank">
          <span v-if="getOwnerName">{{ getOwnerName }}</span>
          <span v-else>{{ getOwnerLink }}</span>
        </a>
        <span v-else-if="getOwnerName">{{ getOwnerName }}</span>
      </div>

      <div class="background" :style="getBackgroundStyling"></div>

      <!-- Mobile top ads -->
      <div
        class="amazon-ads amazon-ads--mobile-top"
        v-if="getAffiliateAds && isMobile"
      >
        <div class="amazon-ads__header">
          <span class="amazon-ads__label">Ad</span>
          Sponsored
        </div>
        <div class="amazon-ads__items">
          <a
            v-for="(ad, index) in getStickyAds"
            :key="'affiliate_mobile_' + index"
            :href="ad.link"
            target="_blank"
            rel="noopener nofollow sponsored"
            class="amazon-ads__item"
            :class="'partner-' + ad.partner"
          >
            <img :src="ad.image" />
            <span v-if="ad.title" class="amazon-ads__item-title">{{
              ad.title
            }}</span>
            <span v-if="ad.partner" class="amazon-ads__item-partner"
              >{{ ad.partner === "amazon" ? "Ad" : "Link" }} from
              {{ ad.partner }}</span
            >
          </a>
        </div>
        <p class="amazon-ads__disclaimer">
          As an Amazon Associate I earn from qualifying purchases.
        </p>
      </div>

      <div
        id="content"
        class="content"
        :class="getContentContainerClasses"
        :style="getContainerHeight"
      >
        <div class="left">
          <div class="filter-button" @click="triggerShowFilter">
            <span v-if="!showFilter">Show Filter</span>
            <span v-else>Close filter</span>
          </div>
          <div class="filter-slider" :class="{ active: showFilter }">
            <table id="filter-table">
              <tr>
                <th colspan="3">Total available characters</th>
              </tr>
              <tr>
                <td colspan="3" class="total" :class="{ new: newAvailable }">
                  {{ availableCount }}
                </td>
              </tr>
              <tr>
                <th>Remove</th>
                <th>Filter</th>
                <th>Available</th>
              </tr>
              <tr
                v-for="(item, index) in getAllCategories"
                :key="'category_' + index"
                :class="{ remove: item.checked }"
                :id="'filter_' + index"
              >
                <td>
                  <input
                    type="checkbox"
                    :value="item.value"
                    @change="
                      event => {
                        filterCheckboxChecked(event, 'filter_' + index);
                      }
                    "
                    v-model="item.checked"
                  />
                </td>
                <td>{{ item.value }}</td>
                <td class="count">{{ item.count }}</td>
              </tr>
            </table>
          </div>
          <div class="button-container" :class="{ fixed: fixedScrolling }">
            <char-button
              class="draw"
              :color="'orange'"
              v-if="!startPicking"
              @click="triggerStartPicking"
            >
              <span>Start picking</span>
            </char-button>
            <char-button
              class="draw"
              v-else
              :color="'orange'"
              @click="pickNextChar"
            >
              <span>Pick next</span>
            </char-button>

            <div class="buttons-row">
              <char-button
                class="draw filter"
                :color="'black'"
                v-if="!startPicking"
                @click="triggerShowFilter"
              >
                <span v-if="!showFilter">Show Filter</span>
                <span v-else>Close filter</span>
              </char-button>
              <char-button
                class="draw toggle-selection"
                :color="'black'"
                v-if="!startPicking"
                @click="triggerToggleSelection"
              >
                <span v-if="toggleAllOff">Add all</span>
                <span v-else>Remove all</span>
              </char-button>
            </div>

            <div class="usergame-container">
              <char-button
                class="user-button draw-next"
                v-if="startPicking"
                :size="'small'"
                @click="triggerStartPicking"
                >Pick again</char-button
              >
              <char-button
                class="user-button reset"
                v-if="startPicking"
                :size="'small'"
                @click="resetAllPicking"
                >Reset all</char-button
              >
            </div>
          </div>

          <char-tabs
            @clicked="triggerTabChange"
            :isMobile="isMobile"
            v-if="tabData.length > 1"
            :tabs="tabData"
          ></char-tabs>

          <table id="character-table">
            <tr>
              <th v-if="!isMobile">Remove</th>
              <th v-else>-</th>
              <th>Name</th>
              <th class="type">Type</th>
              <th class="from">From</th>
            </tr>
            <tr
              v-for="(char, index) in getFilteredGameChars"
              :key="'char_' + index"
              :class="{
                remove: char.remove,
                hover: char.hovered,
                current: char.selected,
                picked: char.picked
              }"
              @mouseover="
                event => {
                  displayPreview(char.index, event);
                }
              "
              @mouseout="
                event => {
                  tearDownDisplayPreview(char.index, event);
                }
              "
              @click="hoverClick"
            >
              <td>
                <input
                  :id="char.index"
                  v-model="char.remove"
                  @click.stop="
                    event => {
                      characterCheckboxChecked(char.index);
                    }
                  "
                  type="checkbox"
                  :value="char.index"
                />
              </td>
              <td class="name">{{ char.name }}</td>
              <td class="type" v-html="changeTypeHtml(char.type)"></td>
              <td class="from">{{ char.container }}</td>
            </tr>
          </table>

          <button class="report-btn-inline" @click="reportOpen = true">
            &#9888; Report wrong data
          </button>

          <img
            id="tumbnail"
            :src="thumbnailImg"
            class="tumbnail"
            :class="{ hidden: thumbnailHide, active: thumbnailActive }"
            :style="{
              top: thumbnailCssTop,
              left: thumbnailCssLeft,
              maxWidth: thumbnailZoomHeight,
              maxHeight: thumbnailZoomHeight
            }"
          />
        </div>
        <div
          class="right"
          :class="{
            fixed: fixedScrolling,
            display: displayPicked,
            down: animateDown
          }"
        >
          <img
            id="picture"
            :src="pictureImg"
            class="picture"
            :class="{ hidden: !startPicking }"
            :style="{ opacity: pictureOpacity }"
          />
        </div>
      </div>
      <!-- Fixed sidebar: hidden when bottom ads are in view -->
      <transition name="ads-slide">
        <div
          class="amazon-ads amazon-ads--sticky"
          :class="{ 'picking-fade': startPicking }"
          v-if="getAffiliateAds && !affiliateAdsReached && !isMobile"
        >
          <div class="amazon-ads__header">
            <span class="amazon-ads__label">Ad</span>
            Sponsored
          </div>
          <div class="amazon-ads__items">
            <a
              v-for="(ad, index) in getStickyAds"
              :key="'affiliate_sticky_' + index"
              :href="ad.link"
              target="_blank"
              rel="noopener nofollow sponsored"
              class="amazon-ads__item"
              :class="'partner-' + ad.partner"
            >
              <img :src="ad.image" />
              <span v-if="ad.title" class="amazon-ads__item-title">{{
                ad.title
              }}</span>
              <span v-if="ad.partner" class="amazon-ads__item-partner"
                >{{ ad.partner === "amazon" ? "Ad" : "Link" }} from
                {{ ad.partner }}</span
              >
            </a>
          </div>
          <p class="amazon-ads__disclaimer">
            As an Amazon Associate I earn from qualifying purchases.
          </p>
        </div>
      </transition>

      <div class="copyright-disclaimer" v-if="getOwnerName || getOwnerLink">
        <p>
          The information presented on this site about
          {{ game.background.title }}, both literal and graphical, is
          copyrighted by
          <a v-if="getOwnerLink" :href="getOwnerLink" target="_blank">{{
            getOwnerName || getOwnerLink
          }}</a
          ><span v-else>{{ getOwnerName }}</span
          >.
        </p>
        <p>
          This website is not produced, endorsed, supported, or affiliated with
          <a v-if="getOwnerLink" :href="getOwnerLink" target="_blank">{{
            getOwnerName || getOwnerLink
          }}</a
          ><span v-else>{{ getOwnerName }}</span
          >.
        </p>
      </div>

      <!-- Sentinel: marks where the bottom ads live -->
      <div ref="affiliateSentinel"></div>

      <!-- Bottom ads: always visible -->
      <div class="amazon-ads amazon-ads--bottom" v-if="getAffiliateAds">
        <div class="amazon-ads__header">
          <span class="amazon-ads__label">Ad</span>
          Sponsored
        </div>
        <div class="amazon-ads__items">
          <a
            v-for="(ad, index) in getAffiliateAds.ads"
            :key="'affiliate_bottom_' + index"
            :href="ad.link"
            target="_blank"
            rel="noopener nofollow sponsored"
            class="amazon-ads__item"
            :class="'partner-' + ad.partner"
          >
            <img :src="ad.image" />
            <span v-if="ad.title" class="amazon-ads__item-title">{{
              ad.title
            }}</span>
            <span v-if="ad.partner" class="amazon-ads__item-partner"
              >{{ ad.partner === "amazon" ? "Ad" : "Link" }} from
              {{ ad.partner }}</span
            >
          </a>
        </div>
        <p class="amazon-ads__disclaimer">
          As an Amazon Associate I earn from qualifying purchases.
        </p>
      </div>

      <div id="cover"></div>
      <div id="coverContent"></div>

      <div
        class="hidden-image-load"
        v-for="(chars, index) in getFilteredGameChars"
        :key="'hidden_img_' + index"
      >
        <img :src="chars.image" />
      </div>
    </div>
    <!--<div v-else-if="!userLoggedIn">You are not logged in!</div>-->

    <div v-else class="skeleton-page">
      <div class="skeleton-tabs">
        <div class="skeleton-shimmer skeleton-tab-item"></div>
        <div class="skeleton-shimmer skeleton-tab-item"></div>
      </div>
      <div class="skeleton-shimmer skeleton-title"></div>
      <div class="skeleton-main">
        <div class="skeleton-left-panel">
          <div class="skeleton-shimmer skeleton-btn"></div>
          <div
            class="skeleton-shimmer skeleton-row"
            v-for="i in 10"
            :key="i"
          ></div>
        </div>
        <div class="skeleton-right-panel">
          <div class="skeleton-shimmer skeleton-image"></div>
        </div>
      </div>
    </div>

    <!-- Report data button -->
    <button
      class="report-btn"
      :class="{ 'picking-fade': startPicking }"
      @click="reportOpen = true"
      title="Report missing or incorrect game data"
    >
      &#9888; Report wrong data
    </button>

    <!-- Report popup -->
    <transition name="report-fade">
      <div class="report-overlay" v-if="reportOpen" @click.self="closeReport">
        <div class="report-modal">
          <template v-if="!reportSent">
            <h3>Report a data issue</h3>
            <p class="report-subtitle">
              Spotted a missing expansion, wrong character, or other data
              problem? Let me know!
            </p>
            <label>
              <span>Your email <span class="optional">(optional)</span></span>
              <input
                v-model="reportEmail"
                type="email"
                placeholder="your@email.com"
              />
            </label>
            <label>
              <span>Description <span class="required">*</span></span>
              <textarea
                v-model="reportDescription"
                placeholder="What's wrong? (e.g. missing character, wrong expansion name...)"
                rows="4"
              ></textarea>
            </label>
            <p class="report-error" v-if="reportError">{{ reportError }}</p>
            <div class="report-actions">
              <button class="btn-cancel" @click="closeReport">Cancel</button>
              <button
                class="btn-send"
                @click="submitReport"
                :disabled="reportSending"
              >
                {{ reportSending ? "Sending..." : "Send report" }}
              </button>
            </div>
          </template>
          <template v-else>
            <div class="report-success">
              <div class="report-success__icon">&#10003;</div>
              <h3>Thank you!</h3>
              <p>
                Your report helps make the data better for everyone. I
                appreciate it!
              </p>
              <button class="btn-send" @click="closeReport">Close</button>
            </div>
          </template>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from "vuex";
import config from "../../../config/config";
import intersection from "lodash/intersection";
import filter from "lodash/filter";
import forEach from "lodash/forEach";
import range from "lodash/range";
import clone from "lodash/clone";
import first from "lodash/first";
import shuffle from "lodash/shuffle";
import PageTabs from "../PageTabs/PageTabs";
import CharTabs from "./CharTabs";
import CharButton from "../CharButton";
import Login from "../Login/Login";
let unknownPerson = "./unknown.png";

let blankState = () => {
  return {
    title: "Pick random",
    showLoginBox: false,
    removingPreformed: false,
    toggleAllOff: false,
    selectedCharacterTabIndex: 0,
    isMobile: false,

    startPicking: false,
    animatePicking: false,
    displayPicked: false,
    animateDown: false,
    fixedScrolling: false,
    showFilter: false,
    newAvailable: false,
    pictureOpacity: 0,
    pictureImg: "",
    contentHeight: 0,
    availableCount: 0,

    thumbnailImg: "",
    thumbnailCssTop: 0,
    thumbnailCssLeft: 0,
    thumbnailHide: true,
    thumbnailActive: false,
    thumbnailZoomHeight: undefined,

    affiliateAdsReached: false,

    reportOpen: false,
    reportEmail: "",
    reportDescription: "",
    reportError: "",
    reportSending: false,
    reportSent: false
  };
};

export default {
  name: "CharacterPicker",
  components: { Login, CharButton, CharTabs, PageTabs },
  props: ["gameId"],
  data() {
    return blankState();
  },
  head: function() {
    let head = {};
    head.title = {
      inner: this.title ? this.title + " - randomboardgame" : "randomboardgame"
    };
    let imgUrl =
      this.game && this.game.background && this.game.background.thumbnail
        ? this.game.background.thumbnail
        : this.game && this.game.background && this.game.background.url
        ? this.game.background.url
        : undefined;
    if (imgUrl && !imgUrl.startsWith("http"))
      imgUrl = config.backendServer + "/" + imgUrl;
    const pageUrl = this.gameId
      ? config.vueServer + "/game/" + this.gameId
      : config.vueServer;
    const description = this.title
      ? "Randomly pick characters and heroes for " +
        this.title +
        ". Use the randomizer to draft your party."
      : "Randomly pick characters and heroes for your board games.";
    head.link = [{ rel: "canonical", href: pageUrl }];
    head.meta = [];
    head.meta.push({ name: "description", content: description });
    head.meta.push({ property: "og:type", content: "website" });
    head.meta.push({ property: "og:url", content: pageUrl });
    if (this.title)
      head.meta.push({
        property: "og:title",
        content: this.title + " - randomboardgame"
      });
    head.meta.push({ property: "og:description", content: description });
    if (imgUrl) head.meta.push({ property: "og:image", content: imgUrl });
    head.meta.push({ name: "twitter:card", content: "summary_large_image" });
    if (this.title)
      head.meta.push({
        name: "twitter:title",
        content: this.title + " - randomboardgame"
      });
    head.meta.push({ name: "twitter:description", content: description });
    if (imgUrl) head.meta.push({ name: "twitter:image", content: imgUrl });

    return head;
  },
  watch: {
    startPicking(val) {
      document.body.classList.toggle("picking-active", val);
      document
        .querySelectorAll(
          ".floatingchat-container-wrap, .floatingchat-container-wrap-mobi"
        )
        .forEach(kofi => {
          kofi.style.transition = "opacity 0.4s ease";
          kofi.style.opacity = val ? "0" : "1";
          kofi.style.pointerEvents = val ? "none" : "";
        });
    }
  },
  computed: {
    ...mapGetters("user", ["userLoggedIn"]),
    ...mapState("game", ["game", "userGames", "isUserGame"]),
    getAllCategories() {
      let tab = this.game ? this.game.tabs[this.selectedCharacterTabIndex] : [];
      if (tab && tab.categories && tab.categories.all)
        return tab.categories.all;
      return [];
    },
    tabData() {
      return this.game ? this.game.tabs : [];
    },
    getFilteredGameChars() {
      return this.game
        ? this.game.tabs[this.selectedCharacterTabIndex].characters
        : [];
    },
    getOwnerName() {
      return this.game.settings && this.game.settings.contentOwnerName
        ? this.game.settings.contentOwnerName
        : undefined;
    },
    getOwnerLink() {
      return this.game.settings && this.game.settings.contentOwnerLink
        ? this.game.settings.contentOwnerLink
        : undefined;
    },
    getBackgroundStyling() {
      let styling = [];
      if (this.game && this.game.background && this.game.background.url) {
        let url = this.game.background.url;
        if (!url.startsWith("http")) url = config.backendServer + "/" + url;
        styling.push('background-image: url("' + url + '")');
      }
      if (this.game && this.game.background && this.game.background.color)
        styling.push("background-color: " + this.game.background.color);
      if (this.game && this.game.background && this.game.background.transparent)
        styling.push("opacity: " + this.game.background.transparent);
      return styling.join(";");
    },
    getContentContainerClasses() {
      let classes = [];
      if (this.startPicking) classes.push("picking");
      if (
        this.game &&
        this.game.settings &&
        this.game.settings.contentContainer
      )
        classes.push(this.game.settings.contentContainer);
      return classes.join(" ");
    },
    getContainerHeight() {
      return this.contentHeight ? "height:" + this.contentHeight + "px" : "";
    },
    getAffiliateAds() {
      return this.game && this.game.affiliate ? this.game.affiliate : null;
    },
    getStickyAds() {
      if (!this.getAffiliateAds || !this.getAffiliateAds.ads) return [];
      return shuffle(this.getAffiliateAds.ads).slice(0, 4);
    }
  },
  methods: {
    ...mapMutations("page", ["setLoadingSpinner"]),
    closeReport() {
      this.reportOpen = false;
      this.reportEmail = "";
      this.reportDescription = "";
      this.reportError = "";
      this.reportSending = false;
      this.reportSent = false;
    },
    async submitReport() {
      if (!this.reportDescription.trim()) {
        this.reportError = "Please describe the issue.";
        return;
      }
      this.reportError = "";
      this.reportSending = true;
      const gameName =
        this.game && this.game.background && this.game.background.title
          ? this.game.background.title
          : "Unknown game";
      try {
        const response = await fetch(config.backendServer + "/email/report", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            description: this.reportDescription,
            email: this.reportEmail,
            game: gameName
          })
        });
        if (!response.ok) throw new Error("Failed to send");
        this.reportSent = true;
      } catch (e) {
        this.reportError = "Something went wrong. Please try again.";
      } finally {
        this.reportSending = false;
      }
    },
    autoSave() {
      this.$store.commit("game/setGame", this.game);
    },
    triggerEditUserGame() {
      this.$router.push({ name: "EditGame", params: { id: this.game.id } });
    },
    async triggerDeleteUserGame() {
      if (
        confirm(
          "Are you sure you want to delete this game? Data can not be restored"
        )
      ) {
        let answer = await this.$store.dispatch(
          "game/deleteUserGame",
          this.game.id
        );
        if (answer && answer.deleted) {
          this.$router.replace({ name: "GameSelection" });
        }
      }
    },
    async triggerCopyAndEditGame() {
      let savedId = await this.$store.dispatch("game/saveUserGame", this.game);
      this.$router.replace({ name: "EditGame", params: { id: savedId } });
    },
    triggerTabChange(index) {
      this.selectedCharacterTabIndex = index;
      let preformedPicking = false;
      this.game.tabs[this.selectedCharacterTabIndex].characters.forEach(
        char => {
          if (char.picked || char.selected || (char.remove && !char.skipp)) {
            preformedPicking = true;
          }
        }
      );
      if (preformedPicking) {
        this.triggerStartPicking(true);
      } else {
        this.resetAllPicking();
      }
      this.reCountAllFilters();
    },
    changeTypeHtml(value) {
      return value.replace(/\//g, " / <wbr>");
    },
    filterCheckboxChecked(event, index) {
      let self = this;
      let target = event.target;
      let targetValue = target ? target.value : event;
      targetValue = targetValue.split("/");
      let checkedIndex =
        index.constructor === String
          ? parseInt(index.replace("filter_", ""))
          : index;
      const checkedItem = this.game.tabs[this.selectedCharacterTabIndex]
        .categories.all[checkedIndex];
      if (checkedItem.checked) {
        this.game.tabs[this.selectedCharacterTabIndex].characters.forEach(
          char => {
            const objectType = char.type.split("/");
            const objectContainer = char.container.split("/");
            if (
              intersection(targetValue, objectType).length > 0 ||
              intersection(targetValue, objectContainer).length > 0
            ) {
              char.skipp = true;
              char.remove = true;
            }
          }
        );
      } else {
        this.game.tabs[this.selectedCharacterTabIndex].characters.forEach(
          char => {
            const objectType = char.type.split("/");
            const objectContainer = char.container.split("/");
            if (
              (intersection(targetValue, objectType).length > 0 ||
                intersection(targetValue, objectContainer).length > 0) &&
              !isObjectDualChecked(objectType, objectContainer)
            ) {
              char.skipp = false;
              char.remove = false;
            }
          }
        );
      }
      this.reCountAllFilters();
      //this.autoSave();

      function isObjectDualChecked(objectType, objectContainer) {
        let tab = self.game.tabs[self.selectedCharacterTabIndex];
        let filterValues =
          tab && tab.categories && tab.categories.all ? tab.categories.all : [];
        const checkedInputs = filter(filterValues, cat => {
          return cat.checked;
        });
        let checkCount = 0;
        for (let i = 0; i < checkedInputs.length; i++) {
          let checkboxValue = checkedInputs[i].value.split("/");
          if (
            intersection(checkboxValue, objectType).length > 0 ||
            intersection(checkboxValue, objectContainer).length > 0
          ) {
            checkCount++;
          }
        }
        return checkCount > 0;
      }
    },
    characterCheckboxChecked(index) {
      const isChecked = document.getElementById(index).checked;
      this.game.tabs[this.selectedCharacterTabIndex].characters[
        index
      ].skipp = isChecked;
      this.thumbnailHide = true;
      this.thumbnailActive = false;
      this.removingPreformed = true;
      this.reCountAllFilters();
      this.autoSave();
    },
    reCountAllFilters(init) {
      let self = this;
      let tab = this.game.tabs[this.selectedCharacterTabIndex];
      let loopValues =
        tab && tab.categories && tab.categories.all ? tab.categories.all : [];
      loopValues.forEach(cat => {
        let filterValues = cat.value.split("/");
        let count = 0;
        this.game.tabs[this.selectedCharacterTabIndex].characters.forEach(
          char => {
            if (
              intersection(filterValues, char.type.split("/")).length > 0 ||
              intersection(filterValues, char.container.split("/")).length > 0
            ) {
              if (char.remove === false) count += 1;
            }
          }
        );
        if (count === 0 && init) cat.checked = true;
      });
      let count = 0;
      this.game.tabs[this.selectedCharacterTabIndex].characters.forEach(
        char => {
          if (char.remove === false) count += 1;
        }
      );
      this.availableCount = count;
      this.newAvailable = true;
      setTimeout(function() {
        self.newAvailable = false;
      }, 100);
      //this.autoSave();
    },
    tearDownDisplayPreview(index) {
      this.game.tabs[this.selectedCharacterTabIndex].characters[
        index
      ].hovered = false;
      this.thumbnailHide = true;
      this.thumbnailActive = false;
      this.thumbnailZoomHeight = undefined;
    },
    hoverClick() {
      if (this.isMobile) {
        if (!this.thumbnailActive) {
          this.thumbnailHide = false;
          this.thumbnailActive = true;
          if (
            this.game &&
            this.game.settings &&
            this.game.settings.zoomHeight
          ) {
            this.thumbnailZoomHeight = this.game.settings.zoomHeight + "px";
          }
        } else {
          this.thumbnailHide = true;
          this.thumbnailActive = false;
        }
      } else {
        this.thumbnailActive = true;
        if (this.game && this.game.settings && this.game.settings.zoomHeight) {
          this.thumbnailZoomHeight = this.game.settings.zoomHeight + "px";
        }
      }
    },
    displayPreview(index, event) {
      let currentHovered = this.game.tabs[this.selectedCharacterTabIndex]
        .characters[index];
      currentHovered.hovered = true;
      this.thumbnailImg =
        currentHovered.image !== undefined
          ? currentHovered.image
          : unknownPerson;
      this.thumbnailCssTop = event.layerY + 40 + "px";
      this.thumbnailCssLeft =
        event.layerX -
        document.getElementById("tumbnail").offsetWidth / 2 +
        "px";
      if (this.isMobile) this.thumbnailCssLeft = "1%";
      this.thumbnailHide = false;
    },
    triggerShowFilter() {
      this.showFilter = this.showFilter ? false : true;
    },
    triggerToggleSelection() {
      let self = this;
      let preformToggle = () => {
        self.toggleAllOff = !self.toggleAllOff ? true : false;
        self.game.tabs[self.selectedCharacterTabIndex].categories.all.forEach(
          (cat, index) => {
            cat.checked = self.toggleAllOff;
            self.filterCheckboxChecked(cat.value, index);
          }
        );
        self.reCountAllFilters();
      };

      if (this.removingPreformed) {
        let selection = !this.toggleAllOff ? "deselect" : "select";
        if (
          confirm(
            "You have already manually removed/added something on the list. Are you sure you want to " +
              selection +
              " everything?"
          )
        ) {
          preformToggle();
          this.removingPreformed = false;
        }
      } else {
        preformToggle();
      }
    },
    triggerStartPicking(skippFirstPick = false) {
      if (!this.startPicking)
        this.contentHeight =
          document.getElementById("content").offsetHeight + 600;

      this.startPicking = true;
      if (!skippFirstPick) this.animateRandomPick();
    },
    resetAllPicking() {
      this.contentHeight = 0;
      this.startPicking = false;
      this.pictureOpacity = 0;
      this.game.tabs[this.selectedCharacterTabIndex].characters.forEach(
        char => {
          char.picked = false;
          char.selected = false;
          if (!char.skipp) char.remove = false;
        }
      );
    },
    pickNextChar() {
      if (this.animatePicking) {
        return;
      }
      this.game.tabs[this.selectedCharacterTabIndex].characters.forEach(
        char => {
          if (char.selected && !char.remove) {
            char.remove = true;
            char.picked = true;
          }
        }
      );
      this.animateRandomPick();
    },
    animateRandomPick() {
      if (!config.debug) {
        this.$ga.event({
          eventCategory: "CharacterPicker",
          eventAction: "picking"
        });
      }
      if (this.animatePicking) {
        return;
      }
      let self = this;
      this.pictureOpacity = 0;
      setTimeout(function() {
        self.pictureImg = unknownPerson;
      }, 500);
      this.animatePicking = true;
      let abortPicking = false;
      forEach(range(0, 101), function(value, index) {
        setTimeout(function() {
          if (!abortPicking) {
            abortPicking = drawOneRandom(index === 100);
          }
          if (index === 100) {
            self.animatePicking = false;
            self.displayPicked = true;
            setTimeout(() => {
              self.animateDown = true;
            }, 1500);
            setTimeout(() => {
              self.displayPicked = false;
              self.animateDown = false;
            }, 2000);
          }
        }, 10 * index);
      });

      function drawOneRandom(finalPick) {
        let available = filter(
          clone(self.game.tabs[self.selectedCharacterTabIndex].characters),
          function(value) {
            return value.remove === false && value.skipp === false;
          }
        );
        if (available.length <= 0) {
          alert("All characters picked!");
          return true;
        }
        let currentPicked = first(shuffle(available));
        markPickedTable(currentPicked);
        if (finalPick) {
          self.pictureImg =
            currentPicked.image !== undefined
              ? currentPicked.image
              : unknownPerson;
          self.pictureOpacity = 1;
        }
        return false;

        function markPickedTable(char) {
          resetPicked();
          self.game.tabs[self.selectedCharacterTabIndex].characters[
            char.index
          ].selected = true;
          if (finalPick) {
            document.getElementById(char.index).focus();
          }
        }

        function resetPicked() {
          self.game.tabs[self.selectedCharacterTabIndex].characters.forEach(
            char => {
              char.selected = false;
            }
          );
        }
      }
    }
  },
  async destroyed() {
    document.body.classList.remove("picking-active");
    let self = this;
    let obj = blankState();
    Object.keys(obj).forEach(key => {
      self[key] = obj[key];
    });
    this.$store.commit("game/clearGame");
  },
  async mounted() {
    let w;
    w = window ? window.innerWidth : w;
    w =
      document && document.documentElement
        ? document.documentElement.clientWidth
        : w;
    w = document && document.body ? document.body.clientWidth : w;
    this.isMobile = w < 990;

    let self = this;
    this.$store.commit("page/setLoadingSpinner", true);

    let waitOnUserLoad = async index => {
      if (!self.userGames && index < 10) {
        setTimeout(() => {
          return waitOnUserLoad(index + 1);
        }, 50);
      } else {
        this.$store.commit("page/setLoadingSpinner", false);
        let idSplit = window.location.href.split("/");
        await this.$store.dispatch(
          "game/downloadGame",
          idSplit[idSplit.length - 1]
        );
        if (this.game && this.game.background && this.game.background.title) {
          this.title = this.game.background.title;
          self.$emit("updateHead");
        }
        this.reCountAllFilters(true);
        this.autoSave();

        document.addEventListener("scroll", () => {
          var scrollTop =
            (window.pageYOffset || document.scrollTop) -
            (document.clientTop || 0);
          self.fixedScrolling = scrollTop > 130;

          if (self.$refs.affiliateSentinel) {
            const rect = self.$refs.affiliateSentinel.getBoundingClientRect();
            self.affiliateAdsReached = rect.top <= window.innerHeight * 0.85;
          }
        });
      }
    };
    waitOnUserLoad(0);
    //(this.userLoggedIn) ? waitOnUserLoad(0) : waitOnUserLoad(10);
  }
};
</script>

<style lang="less">
.buttons-row {
  .draw {
    display: inline-block;
    margin-left: 30px;
    &:first-child {
      margin-left: 0;
    }
    @media (max-width: 650px) {
      margin-left: 0;
    }
  }
}
.button-container {
  margin-bottom: 20px;
  &.fixed {
    position: fixed;
    left: 20px;
    top: 100px;
    width: 126px;
    z-index: 1;
    .draw {
      margin-left: 0;
      &.filter {
        display: none;
      }
      &.toggle-selection a {
        font-size: 16px;
        background: white;
        &:hover {
          background: #bdbdbd;
        }
      }
    }
    .button-container {
      margin-bottom: 0;
      a {
        min-width: 120px !important;
        margin-bottom: 20px;
        padding: 15px 10px;
      }
    }
    .usergame-container {
      .user-button {
        width: 126px;
        margin: 0;
        display: inline-block;
      }
    }
  }
}
</style>

<style scoped lang="less">
.mobile {
  .content {
    margin: 120px 5%;
    width: 90%;
    &.picking {
      margin: 120px 5%;
      width: 90%;
    }
    .left {
      table {
        width: 100%;
        td {
          padding: 10px 2px;
          font-size: 12px;
          border-bottom: 1px solid black;
          &.type {
            width: 30%;
          }
          &.from {
            width: 20%;
          }
        }
        input {
          width: 17px;
        }
      }
      img.tumbnail {
        &.active {
          max-width: 96% !important;
        }
      }
    }
  }
}

.usergame-container {
  .user-button {
    margin: 5px;
    display: inline-block;
  }
  .login-box {
    display: inline-block;
    background: rgba(255, 255, 255, 0.92);
    border-radius: 10px;
    padding: 10px 16px;
    animation: fadeIn 0.4s ease;
  }
  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
}
h1 {
  &.withcreator {
    margin-bottom: 10px;
  }
}
.game-creator {
  margin-bottom: 80px;
  a {
    color: #f76331;
  }
}
.copyright-disclaimer {
  margin-top: 0;
  padding: 20px;
  background: #f5f5f5;
  border-bottom: 3px solid #e0e0e0;
  border-top: 3px solid #e0e0e0;
  text-align: center;
  font-size: 12px;
  color: #888;
  a {
    color: #888;
    text-decoration: underline;
  }
}
.content {
  .left {
    .filter-button {
      display: block;
      color: #222;
      background: transparent;
      position: fixed;
      text-transform: uppercase;
      font-size: 20px;
      padding: 20px 10px;
      top: 0;
      left: 20px;
      width: 100px;
      border: 3px solid #000;
      border-top: transparent;
      border-radius: 0 0 3px 3px;
      cursor: pointer;
      &:hover {
        background: #cccccc;
      }
    }

    .filter-slider {
      position: fixed;
      width: 25%;
      z-index: 10;
      top: 100px;
      left: -100%;
      max-height: 80%;
      -webkit-transition: left 0.5s;
      -moz-transition: left 0.5s;
      -o-transition: left 0.5s;
      transition: left 0.5s;
      &.active {
        left: 0;
        border: 1px solid black;
        background: #eeeeee;
        padding: 20px 20px 20px 0;
        overflow-y: scroll;
        overflow-x: hidden;
        z-index: 100000001;
      }
    }

    table {
      width: 90%;
      display: inline-table;
      border: 1px solid black;
      border-radius: 3px;
      border-collapse: collapse;
      background: #ffffff;
      th {
        background: #222222;
        color: #ffffff;
        padding: 6px 0;
      }
      td {
        text-align: center;
        &.name {
          text-transform: uppercase;
        }
        &.total {
          -webkit-transition: font-size 0.5s;
          -moz-transition: font-size 0.5s;
          -o-transition: font-size 0.5s;
          transition: font-size 0.5s;
          font-size: 24px;
          height: 35px;
          &.new {
            -webkit-transition: font-size 0.1s;
            -moz-transition: font-size 0.1s;
            -o-transition: font-size 0.1s;
            transition: font-size 0.1s;
            font-size: 0;
          }
        }
      }
    }

    table#filter-table {
      width: 100%;
      th,
      td {
        /*padding: 0 20px 0 10px;*/
      }
    }

    img.tumbnail {
      position: absolute;
      max-width: 200px;
      max-height: 200px;
      border: 1px solid black;
      z-index: 50;
      &.active {
        max-width: 400px;
        max-height: 400px;
        border: 3px solid black;
        border-radius: 20px;
        -webkit-transition: all 1s;
        -moz-transition: all 1s;
        -o-transition: all 1s;
        transition: all 1s;
      }
    }

    input {
      width: 55px;
      height: 17px;
    }
  }

  .right {
    img {
      max-width: 90%;
      height: auto;
      border-radius: 60px;
      border: 3px solid black;
      display: inline-block;
      &.picture {
        transition: 0.5s opacity;
      }
    }
  }
}

tr td {
  -webkit-transition: background 0.5s, color 0.5s;
  -moz-transition: background 0.5s, color 0.5s;
  -o-transition: background 0.5s, color 0.5s;
  transition: background 0.5s, color 0.5s;
}

tr.remove td {
  text-decoration: line-through;
  background: grey;
  color: #ccc;
}
tr.current td {
  animation: pulse 1s infinite;
  color: white !important;
}

@keyframes pulse {
  0% {
    background-color: #038021;
  }
  50% {
    background-color: #25b308;
  }
  100% {
    background-color: #038021;
  }
}
tr.hover td {
  background-color: #5ec1ff;
  color: black;
}

tr.picked td {
  background-color: #fffc8d;
  color: black;
  height: 24px;
}
tr.picked td input {
  display: none;
}

@media (max-width: 990px) {
  .content .left .filter-button {
    position: initial;
    width: auto;
    display: inline-block;
    font-size: 14px;
    border-radius: 2px;
    margin-bottom: 20px;
    padding: 10px 30px;
    font-weight: bold;
    border-top: 3px solid black;
  }

  .content .left .filter-slider {
    position: initial;
    max-height: 0;
    overflow: hidden;
    width: auto;
    -webkit-transition: max-height 0.5s;
    -moz-transition: max-height 0.5s;
    -o-transition: max-height 0.5s;
    transition: max-height 0.5s;
  }

  .content .left .filter-slider.active {
    max-height: 1000px;
    padding: 20px;
    margin-bottom: 20px;
    overflow: hidden;
  }

  .content .left .button-container.fixed {
    top: 20px;
  }
}

.amazon-ads {
  text-align: center;
  padding: 40px 20px 20px;

  &--sticky {
    position: fixed;
    right: 20px;
    top: 50%;
    transform: translateY(-50%);
    z-index: 100;
    padding: 10px;
    background: rgba(255, 255, 255, 0.97);
    border-radius: 10px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);

    .amazon-ads__header {
      font-size: 10px;
      margin-bottom: 8px;
    }

    .amazon-ads__items {
      flex-direction: column;
      gap: 10px;
    }

    .amazon-ads__item {
      width: 100px;
      padding: 8px;

      img {
        width: 70px;
        height: 70px;
      }
    }

    .amazon-ads__item-title {
      font-size: 10px;
    }

    .amazon-ads__item-partner {
      font-size: 9px;
      padding-top: 4px;
    }

    .amazon-ads__disclaimer {
      font-size: 9px;
      line-height: 9px;
      margin-top: 10px;
      padding-top: 8px;
      max-width: 120px;
      word-wrap: break-word;
      overflow-wrap: break-word;
      margin-left: auto;
      margin-right: auto;
    }
  }

  &--mobile-top {
    margin-bottom: 20px;
    padding: 14px 10px;
    background: #f5f5f5;
    border-bottom: 3px solid #e0e0e0;

    .amazon-ads__header {
      font-size: 11px;
      margin-bottom: 10px;
    }

    .amazon-ads__items {
      flex-wrap: wrap;
      justify-content: center;
      gap: 10px;
    }

    .amazon-ads__item {
      width: 120px;
      padding: 8px;

      img {
        width: 80px;
        height: 80px;
      }
    }

    .amazon-ads__item-title {
      font-size: 11px;
    }

    .amazon-ads__item-partner {
      font-size: 10px;
    }
  }

  &--bottom {
    margin-top: 40px;
    background: #f5f5f5;
    border-top: 3px solid #e0e0e0;
    border-bottom: 3px solid #e0e0e0;
    padding: 30px 20px;

    .amazon-ads__items {
      max-width: 780px; // 4 × 180px cards + 3 × 20px gaps
      margin-left: auto;
      margin-right: auto;
    }
  }

  &__header {
    font-size: 15px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 1.5px;
    color: #444;
    margin-bottom: 20px;
  }

  &__label {
    display: inline-block;
    background: #444;
    color: #fff;
    font-size: 11px;
    font-weight: 700;
    padding: 2px 7px;
    border-radius: 3px;
    margin-right: 8px;
    vertical-align: middle;
    letter-spacing: 0;
  }

  &__items {
    display: flex;
    justify-content: center;
    gap: 20px;
    flex-wrap: wrap;
  }

  &__item {
    display: flex;
    flex-direction: column;
    align-items: center;
    background: #fff;
    border: 2px solid #e0e0e0;
    border-radius: 8px;
    padding: 14px;
    width: 180px;
    text-decoration: none;
    color: #222;
    transition: box-shadow 0.2s, transform 0.2s;

    &:hover {
      box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
      transform: translateY(-2px);
    }

    &.partner-amazon {
      border-color: #ff9900;

      .amazon-ads__item-partner {
        color: #ff9900;
      }
    }

    img {
      width: 140px;
      height: 140px;
      object-fit: contain;
      margin-bottom: 10px;
    }
  }

  &__item-title {
    font-size: 13px;
    text-align: center;
    line-height: 1.3;
    margin-bottom: 6px;
  }

  &__item-partner {
    font-size: 11px;
    text-transform: capitalize;
    font-weight: bold;
    margin-top: auto;
    padding-top: 8px;
  }

  &__disclaimer {
    font-size: 12px;
    font-style: italic;
    color: #666;
    margin-top: 20px;
    border-top: 1px solid #ddd;
    padding-top: 12px;
    max-width: 400px;
    margin-left: auto;
    margin-right: auto;
  }
}

.ads-slide-enter-active,
.ads-slide-leave-active {
  transition: right 0.35s ease, opacity 0.35s ease;
}
.ads-slide-enter,
.ads-slide-leave-to {
  right: -300px;
  opacity: 0;
}

body {
  position: relative;
  font-family: sans-serif;
}

h3 {
  font-size: 23px;
  margin: 0 0 20px 0;
  color: white;
}

#cover {
  position: fixed;
  top: 0;
  left: 0;
  background: black;
  opacity: 0;
  z-index: 30;
  width: 0;
  height: 0;
  -webkit-transition: opacity 0.65s;
  -moz-transition: opacity 0.65s;
  -o-transition: opacity 0.65s;
  transition: opacity 0.65s;
}

#cover.active {
  opacity: 0.75;
  width: 100%;
  height: 100%;
}

#coverContent {
  position: fixed;
  top: 100%;
  z-index: 31;
  background: white;
  margin: 0 10%;
  padding: 50px 5%;
  max-height: 65%;
  overflow-y: scroll;
  /*overflow-y: scroll;*/
  text-align: center;
  width: 70%;
  border-radius: 20px;
  -webkit-transition: top 0.75s;
  -moz-transition: top 0.75s;
  -o-transition: top 0.75s;
  transition: top 0.75s;
}

#coverContent .button {
  background: #444;
  border: 3px solid black;
  text-decoration: initial;
  font-size: 25px;
  color: white;
  padding: 20px;
  width: 60%;
  display: inline-block;
  border-radius: 20px;
  margin-bottom: 10px;
}

#coverContent .button:hover {
  background: #666;
}

#coverContent.active {
  position: fixed;
  top: 120px;
}

.background {
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 50%;
  position: fixed;
  top: 0;
  height: 100%;
  width: 100%;
  z-index: -1;
}

.content {
  margin: 120px 10%;
  width: 80%;
  /*font-size: 0;*/
  text-align: center;
  opacity: 1;
  /* position: absolute; */
  z-index: 10;
}

.content .left,
.content .right {
  margin-top: 30px;
  width: 100%;
  display: inline-block;
  vertical-align: top;
  text-align: center;
  -webkit-transition: width 0.5s;
  -moz-transition: width 0.5s;
  -o-transition: width 0.5s;
  transition: width 0.5s;
}

.content.picking .left {
  float: left;
}

.content.picking .left,
.content.picking .right {
  width: 50%;
}

.content.picking.bigger {
  margin: 120px 0 120px 10%;
  width: 90%;
  .left {
    width: 40%;
  }
  .right {
    width: 60%;
    &.fixed {
      width: 55%;
      left: 44%;
    }
  }
  @media (max-width: 1550px) {
    .left {
      width: 45%;
    }
    .right {
      width: 55%;
      &.fixed {
        width: 50%;
        left: 48%;
      }
    }
  }
  @media (max-width: 1450px) {
    .left {
      width: 50%;
    }
    .right {
      width: 50%;
      &.fixed {
        width: 45%;
        left: 52%;
      }
    }
  }
  @media (max-width: 1350px) {
    margin: 120px 5% 120px 15%;
    width: 80%;
    .left {
      width: 50%;
    }
    .right {
      width: 50%;
      &.fixed {
        width: 45%;
        left: 57%;
      }
    }
  }
  @media (max-width: 1200px) {
    margin: 120px 2.5% 120px 17.5%;
    .left {
      width: 50%;
    }
    .right {
      width: 40%;
      &.fixed {
        width: 40%;
        left: 60%;
      }
    }
  }
  @media (max-width: 1100px) {
    margin: 120px 0% 120px 20%;
    .left {
      width: 65%;
    }
    .right {
      width: 35%;
      &.fixed {
        width: 30%;
        left: 70%;
      }
    }
  }
}

.content .right.fixed {
  position: fixed;
  left: 50%;
  top: 0px;
  width: 40%;
  height: 0;
  overflow: hidden;
  @media (max-width: 1200px) {
    left: 55%;
  }
  @media (max-width: 1100px) {
    left: 60%;
  }
}

.content.picking .right.fixed {
  height: auto;
  overflow: auto;
}

.hidden,
.hidden-image-load {
  display: none;
}

@media (max-width: 990px) {
  .tabs {
    padding-left: 0 !important;
  }
  .content {
    margin: 120px 5%;
    width: 90%;
  }
  .content .left table td {
    word-break: break-word;
  }
  .content.picking {
    margin: 120px 5%;
  }
  .content.picking.bigger {
    margin: 120px 10%;
  }
  .content.picking .left,
  .content.picking .right,
  .content.picking.bigger .left,
  .content.picking.bigger .right {
    width: 100%;
  }

  .content.picking .right.display,
  .content.picking .right.fixed.display,
  .content.picking.bigger .right.display,
  .content.picking.bigger .right.fixed.display {
    position: fixed;
    left: 0;
    top: 25%;
    transition: top 0.5s;
    &.down {
      top: 100%;
    }
  }

  .content .right.fixed,
  .content.bigger .right.fixed,
  .content.picking .right.fixed,
  .content.picking.bigger .right.fixed {
    position: initial;
    width: 100%;
  }
}
</style>
<style lang="less">
@media (max-width: 990px) {
  .content {
    .button-container.fixed {
      .user-button a {
        background: #c4c4c4;
      }
    }
  }
}
</style>
<style scoped lang="less">
.report-btn {
  position: fixed;
  bottom: 90px;
  left: 16px;
  z-index: 1000;
  width: 177.96px;
  height: 46px;
  background: #fff;
  color: #f76331;
  border: 2px solid #f76331;
  border-radius: 50px;
  padding: 0 16px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  font-family: inherit;
  box-sizing: border-box;
  transition: background 0.2s, color 0.2s, transform 0.2s;
  &:hover {
    background: #fff5f2;
    transform: translateY(-2px);
  }
  @media (max-width: 990px) {
    display: none;
  }
}

.report-btn-inline {
  display: none;
  @media (max-width: 990px) {
    display: inline-block;
    margin-top: 16px;
    padding: 10px 20px;
    background: #fff;
    color: #f76331;
    border: 2px solid #f76331;
    border-radius: 50px;
    font-size: 13px;
    font-weight: 600;
    font-family: inherit;
    cursor: pointer;
    &:hover {
      background: #fff5f2;
    }
  }
}

.picking-fade {
  opacity: 0 !important;
  pointer-events: none;
  transition: opacity 0.4s ease;
}

.report-fade-enter-active,
.report-fade-leave-active {
  transition: opacity 0.25s ease;
  .report-modal {
    transition: opacity 0.25s ease, transform 0.25s ease;
  }
}
.report-fade-enter,
.report-fade-leave-to {
  opacity: 0;
  .report-modal {
    opacity: 0;
    transform: translateY(16px) scale(0.97);
  }
}

.report-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
}

.report-modal {
  background: #fff;
  border-radius: 10px;
  padding: 28px 24px;
  width: 100%;
  max-width: 440px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);

  h3 {
    margin: 0 0 6px 0;
    font-size: 20px;
    color: #222;
  }

  .report-subtitle {
    margin: 0 0 20px 0;
    font-size: 14px;
    color: #666;
  }

  label {
    display: flex;
    flex-direction: column;
    text-align: left;
    font-size: 14px;
    font-weight: 600;
    color: #333;
    margin-bottom: 14px;

    input,
    textarea {
      margin-top: 6px;
      padding: 8px 10px;
      font-size: 14px;
      border: 1px solid #ccc;
      border-radius: 6px;
      font-family: inherit;
      resize: vertical;
      &:focus {
        outline: 2px solid #f76331;
        border-color: #f76331;
      }
    }
  }

  .optional {
    font-weight: 400;
    color: #888;
  }

  .required {
    color: #f76331;
  }

  .report-error {
    color: #c0392b;
    font-size: 13px;
    margin: 0 0 12px 0;
  }

  .report-actions {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    margin-top: 4px;
  }

  .btn-cancel {
    background: none;
    border: 1px solid #ccc;
    border-radius: 6px;
    padding: 8px 16px;
    font-size: 14px;
    font-family: inherit;
    cursor: pointer;
    &:hover {
      background: #f5f5f5;
    }
  }

  .btn-send {
    background: #f76331;
    color: #fff;
    border: none;
    border-radius: 6px;
    padding: 8px 20px;
    font-size: 14px;
    font-weight: 600;
    font-family: inherit;
    cursor: pointer;
    &:hover:not(:disabled) {
      background: #d94e1f;
    }
    &:disabled {
      opacity: 0.6;
      cursor: default;
    }
  }
}

.report-success {
  text-align: center;
  padding: 12px 0;

  &__icon {
    font-size: 48px;
    color: #27ae60;
    line-height: 1;
    margin-bottom: 12px;
  }

  h3 {
    margin-bottom: 10px;
  }

  p {
    color: #555;
    font-size: 15px;
    margin-bottom: 20px;
  }
}

.skeleton-page {
  min-height: calc(100vh - 300px);
  padding: 20px 5% 60px;
  box-sizing: border-box;
}

.skeleton-shimmer {
  background: linear-gradient(90deg, #e0e0e0 25%, #f0f0f0 50%, #e0e0e0 75%);
  background-size: 200% 100%;
  animation: skeleton-shimmer 1.4s infinite;
  border-radius: 4px;
}

@keyframes skeleton-shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

.skeleton-tabs {
  display: flex;
  gap: 10px;
  margin-bottom: 40px;
  padding-left: 145px;

  .skeleton-tab-item {
    width: 80px;
    height: 18px;
    border-radius: 3px;
  }
}

.skeleton-title {
  width: 300px;
  height: 40px;
  margin: 0 auto 60px;
  border-radius: 6px;
}

.skeleton-main {
  display: flex;
  gap: 40px;
  max-width: 1200px;
  margin: 0 auto;

  @media (max-width: 990px) {
    flex-direction: column;
  }
}

.skeleton-left-panel {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 12px;

  .skeleton-btn {
    width: 180px;
    height: 44px;
    margin-bottom: 8px;
    border-radius: 4px;
  }

  .skeleton-row {
    width: 100%;
    height: 28px;
    border-radius: 3px;
  }
}

.skeleton-right-panel {
  width: 300px;
  flex-shrink: 0;

  .skeleton-image {
    width: 100%;
    height: 380px;
    border-radius: 6px;
  }

  @media (max-width: 990px) {
    width: 100%;

    .skeleton-image {
      height: 200px;
    }
  }
}
</style>
